<template>
  <div class="course-result-class-calendar-contain">
    <section class="calendar-filter clearfix">
      <div class="calendar-filter-lf">
        <div class="filter-lf-top">
          <el-button type="primary" :loading="downLoading" @click="exportCalendar">{{ $t('export') }}</el-button>
          <el-button type="primary" :loading="downLoading2" @click="downDetail" >
            {{ $t('courseTask.exportDetail') }}</el-button>
        </div>
        <div class="filter-lf-bottom clearfix">
          <span class="date-title">{{ $t('courseTask.calendarTable') }}</span>
          <span>|</span>
          <span :class="['date-tye', { 'active': dateType === 0 }]" @click="choseDateType(0)">
            {{ $t('courseTask.calendarDay') }}</span>
          <span>|</span>
          <span :class="['date-tye', { 'active': dateType === 1 }]" @click="choseDateType(1)">
            {{ $t('courseTask.calendarWeek') }}</span>
          <span>|</span>
          <span :class="['date-tye', { 'active': dateType === 2 }]" @click="choseDateType(2)">
            {{ $t('courseTask.calendarMonth') }}</span>
        </div>
      </div>
      <div class="calendar-filter-lr clearfix">
        <div class="filter-lr-search clearfix">
          <div class="filter-module clearfix">
            <span class="filter-module-name filter-module-name2" @click="showClass">
              {{ $t('res.cri.roomName') }}
            </span>
            <span class="filter-module-value">
              <el-tooltip class="item"
                  :content="classSearch.classroomName"
                  :disabled="!classSearch.classroomName || classSearch.classroomName.length<6"
                   placement="top">
                   <el-input :placeholder="$t('user.select')"
                   v-model="classSearch.classroomName" clearable readonly></el-input>
              </el-tooltip>
            </span>
          </div>
          <div class="filter-module clearfix">
            <span class="filter-module-name filter-module-name2" @click="showSite">
              {{ $t('res.vehinfo.subordinateSiteId') }}
            </span>
            <span class="filter-module-value">
              <el-tooltip class="item"
                  :content="classSearch.subordinateSite"
                  :disabled="!classSearch.subordinateSite || classSearch.subordinateSite.length<6"
                   placement="top">
                   <el-input :placeholder="$t('user.select')" 
                    v-model="classSearch.subordinateSite" clearable readonly></el-input>
              </el-tooltip>
            </span>
          </div>
          <div class="filter-module clearfix">
            <span class="filter-module-name">
              {{ $t('courseTask.startEndTime') }}
            </span>
            <span class="filter-module-value">
              <el-date-picker
                v-model="classSearch.time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('organization.startData')"
                :end-placeholder="$t('organization.endData')"
                :placeholder="$t('user.checkdate')">
              </el-date-picker>
            </span>
          </div>
          <div class="filter-module clearfix" ref="filterModule">
            <span class="filter-module-name">
              {{ $t('res.cri.classroomClass') }}
            </span>
            <span class="filter-module-value">
              <class-tree ref="classRef"
                          :getSelectList="getSelectList"
                          :defaultProps="defaultProps"
                          :url="queryTreeUrl"
                          :clearClassTreeInfo="clearClassRoomTree"
                          :classlistName="'classinfo'"
                          :isSelect="false"
                          :status="'roomClassStatus'"></class-tree>
            </span>
          </div>
        </div>
        <div class="filter-lr-buttons">
          <el-button class="button-margin-b" type="primary" @click="searchList">
            {{ $t("query") }}
          </el-button>
          <el-button class="el-back M-margin-l" type="info" @click="resetList">
            {{ $t("reset") }}
          </el-button>
        </div>
      </div>
    </section>
    <v-gantt-chart v-loading="dataListLoading"
                    :startTime="times[0]"
                    :endTime="times[1]"
                    :tempStart="classSearch.startDate"
                    :cellWidth="cellWidth"
                    :cellHeight="cellHeight"
                    :timeLines="timeLines"
                    :titleHeight="titleHeight"
                    :scale="scale"
                    :titleWidth="titleWidth"
                    showCurrentTime
                    :hideHeader="false"
                    :dataKey="dataKey"
                    :arrayKeys="arrayKeys"
                    :scrollToPostion="positionB"
                    @scrollLeft="scrollLeftB"
                    customGenerateBlocks
                    :datas="datasB"
                    :queryType="queryType"
                    ref="gantChild"
                    :subHolidayList="holidayList">
        <template v-slot:block="{data,getPositonOffset,getWidthAbout2Times,isInRenderingTimeRange,
        startTimeOfRenderArea,endTimeOfRenderArea,isAcrossRenderingTimeRange}">
          <!--     渲染表格内容     -->
          <table-content :data="data"
                          :cellHeight="cellHeight"
                          :getPositonOffset="getPositonOffset"
                          :isNewScheduleModule="isNewScheduleModule"
                          :getWidthAbout2Times="getWidthAbout2Times"></table-content>
        </template>
        <template v-slot:left="{data}">
          <!--    表格左边（课程名称）      -->
          <LeftBarItem :data="data"></LeftBarItem>
        </template>
        <template v-slot:title>
          <div>
            <div class="class-table-lf">{{ $t('res.courseclassroomrela.classification') }}</div>
            <div class="class-table-lr">{{ $t('res.courseclassroomrela.classroomName') }}</div>
          </div>
        </template>
    </v-gantt-chart>
    <section class="calendar-cards clearfix">
      <div class="calendar-card calendar-card1">{{ $t('courseTask.noImport') }}</div>
      <div class="calendar-card">{{ $t('courseTask.existed') }}</div>
    </section>
    <el-dialog :title="$t('res.courseclassroomrela.alternativeClassroom')"
               :visible="isShowclassroom"
               width="90%"
               :show-close="false"
               :before-close="closeSubClassroomDlg">
      <ClassroomItem ref="trainerInfoRef"
                       v-if="isShowclassroom"
                       @onOk="onOk"
                       @closeSubClassroomDlg="closeSubClassroomDlg"
                       :classroomList="classroomList"></ClassroomItem>
    </el-dialog>
     <!-- 所属场地dialog -->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection="false"
                      :isShow="true"
                      :isQueryShow="false"
                      :selectTable="selectTable"
                      :dialogVisible="isShowSuboSite"
                      @closeSuboSiteDlg="closeSuboSiteDlg"
                      @bringBack="bringBack"></subordinate-site>
  </div>
</template>
<script>
import vGanttChart from '@/views/modules/learning/classroomCalendar/gantt/gantt.vue';
import LeftBarItem from '@/views/modules/learning/classroomCalendar/left-bar-item/LeftBarItem.vue';
import TableContent from '@/views/modules/learning/classroomCalendar/table-content/TableContent.vue';
import ClassroomItem from '@/components/rm/classroom-select/index';
import SubordinateSite from '@/components/rm/subordinateSite-calendar/index';
import ClassTree from '@/components/rm/class-tree/index';
import { getDate, GetMonday, GetSunday } from '@/utils/timeLineUtils.js';
import dayjs from 'dayjs';

export default {
  components: {
    'v-gantt-chart': vGanttChart,
    'class-tree': ClassTree,
    LeftBarItem,
    TableContent,
    ClassroomItem,
    SubordinateSite
  },
  props: {
    taskId: {
      type: String
    },
    taskName:{
      type : String
    },
    taskTime: {
      type: Array
    }
  },
  data() {
    return {
      isNewScheduleModule: true,
      isShowclassroom: false,
      isShowSuboSite: false,
      trainerList: [],
      orgType: this.enums['orgType'],
      orgTypeList: [],
      teamName: '',
      // 教室分类
      defaultProps: {
        children: 'children',
        label: 'roomClassCnName'
      },
      queryTreeUrl: '/rm/classroomclass/list',
      teamcatalogOne: this.enums['catalogidList1'],
      teamcatalogSecond: this.enums['catalogidList2'],
      popWidth: 300,
      companyLoading: false,
      companyOptions: [],
      companyTimeout: null,
      timeout: null,
      dateType: 0,
      classSearch: {
        subordinateSite: '',
        siteIdList: [],
        classroomName: '',
        classroomNoList: [],
        classroomClassList: [],
        classroomIdList: [],
        time: [],
        queryOrgId: ''
      },
      classroomList: [],
      brandQuery: [],
      // 时间线的开始结束时间
      timeLines: [
        {
          time: dayjs()
            .add(2, 'hour')
            .toString()
        },
        {
          time: dayjs()
            .add(5, 'hour')
            .toString(),
          color: '#747e80'
        }
      ],
      currentTime: dayjs(),
      cellWidth: 100, // 默认值100 在进行查询类型切换时进行更改值 月 20  周 15
      cellHeight: 38,
      titleHeight: 60,
      titleWidth: 250,
      // 时间间隔刻度 1440表示1天
      scale: 1440,
      // 设置开始和结束时间 开始时间的下标必须是0，结束是1
      times: [],
      queryType: 'day', // day 在进行查询类型切换时进行更改值 月 month 周 week
      cusTimes: [],
      datasB: [],
      dataKey: 'id',
      scrollToTime: dayjs()
        .add(1, 'day')
        .toString(),
      scrollToPostion: { x: 10000, y: 10000 },
      hideHeader: false,
      isShow: false,
      // 等待转圈
      dataListLoading: false,
      loading: false,
      arrayKeys: ['gtArray', 'error'],
      scrollToY: 0,
      positionB: {},
      positionA: {},
      holidayList: [],
      selectTable: [],
      downTimeout: null,
      downTimeout2: null,
      downLoading: false,
      downLoading2: false
    };
  },
  methods: {
    resetList () {
      this.clearClassRoomTree();
      this.classSearch = {
        subordinateSite: '',
        siteIdList: [],
        classroomName: '',
        classroomNoList: [],
        classroomClassList: [],
        classroomIdList: [],
        time: [],
        queryOrgId: ''
      };
      this.initDate();
      this.searchList();
    },
    showSite () {
      this.isShowSuboSite = true;
      this.$refs.suborSiteRef.initSuborSite();
    },
    closeSuboSiteDlg () {
      this.isShowSuboSite = false;
    },
    closeSubClassroomDlg () {
      this.isShowclassroom = false;
    },
    showClass () {
      this.isShowclassroom = true;
      this.$refs.classroomInfoRef.initMethods();
    },
    // 教室选择完成
    onOk (data) {
      const classroomName = data.map((item) => item.classroomName);
      const ids = data.map((item) => item.classroomNo);
      this.classSearch.classroomName = classroomName.join(',');
      this.classSearch.classroomNoList = ids;
      this.classSearch.classroomIdList = data.map((item) => item.classroomId);
      this.isShowclassroom = false;
      this.classroomList = data;
    },
    // 场地选择
    bringBack (selection) {
      const siteCnName = selection.map((item) => item.siteCnName);
      const ids = selection.map((item) => item.id);
      this.classSearch.subordinateSite = siteCnName.join(',');
      this.classSearch.siteIdList = ids;
      this.isShowSuboSite = false;
      this.selectTable = selection;
    },
    clearClassRoomTree () {
      this.classSearch.classroomClassList = [];
    },
    getSelectList (args) {
      let classroominfo = [];
      if (args && args.length > 0) {
        classroominfo = args.map(item => item.id);
      }
      this.classSearch.classroomClassList = classroominfo;
    },
    choseDateType (val) {
      this.dateType = val;
      switch (val) {
        case 0:
          this.queryType = 'day';
          this.cellWidth = 100;
          break;
        case 0:
          this.queryType = 'week';
          this.cellWidth = 15;
          break;
        case 0:
          this.queryType = 'month';
          this.cellWidth = 10;
          break;
        default:
          break;
      }
      this.searchList();
    },
    dateFormat (date) {
      return date ? dayjs(date).format('YYYY/MM/DD HH:mm:ss') : '';
    },
    dateFormatNew (date) {
      if (new Date(date).getHours() === 9) {
        return dayjs(date).format('YYYY/MM/DD') + ' 00:00:00';
      } else if (new Date(date).getHours() === 17){
        return dayjs(date).format('YYYY/MM/DD') + ' 23:59:59';
      } else {
        return dayjs(date).format('YYYY/MM/DD HH:mm:ss');
      }
    },
    searchList () {
      this.dataListLoading = true;
      const params = {
        taskId: this.taskId,
        startDate: this.classSearch.time.length === 2 ? this.classSearch.time[0] + ' 00:00:00' : '',
        endDate: this.classSearch.time.length === 2 ? this.classSearch.time[1] + ' 23:59:59' : '',
        siteIdList: this.classSearch.siteIdList,
        classroomClassList: this.classSearch.classroomClassList,
        classroomNoList: this.classSearch.classroomNoList,
        classroomIdList: this.classSearch.classroomIdList
      };
      this.$request.post('/classschedule/scheduleTaskResult/classroomCalendar', params).then((res) => {
        this.dataListLoading = false;
        if (res) {
          let start = res.minX;
          let end = res.maxX;
          this.times = [];
          this.holidayList = res.holidayList;
          switch (this.queryType) {
            case 'day':
              this.times.push(start, end);
              break;
            case 'week':
              start = GetMonday(getDate(start));
              end = GetSunday(getDate(end));
              this.times.push(start, end);
              break;
            case 'month':
              this.times.push(dayjs(start).format('YYYY/MM/DD'), dayjs(end).endOf('month').format('YYYY/MM/DD'));
              break;
            default:
              break;
          }
          this.datasB = res.calendarList.map((item) => {
            let gtArray = [];
            if (item.offeringCalendarClassroom) {
              gtArray  = item.offeringCalendarClassroom.map((i) => {
                i.start = i.flag === 0 ? this.dateFormatNew(i.start) : this.dateFormat(i.start);
                i.end = i.flag === 0 ? this.dateFormatNew(i.end) : this.dateFormat(i.end);
                i.startShort = i.flag === 0 ? this.dateFormatNew(i.startShort) : this.dateFormat(i.startShort);
                i.endShort = i.flag === 0 ? this.dateFormatNew(i.endShort) : this.dateFormat(i.endShort);
                return i;
              });
            }
            return { ...item, name: item.roomName, gtArray, catalogName: item.siteName  };
          });
          this.$refs.gantChild.dateDiff(this.times[0],this.times[1]);
        }
      }).catch(() => {
        this.dataListLoading = false;
      });
    },
    initDate () {
      const start =  dayjs(this.taskTime[0]).format('YYYY-MM-DD');
      const end = dayjs(this.taskTime[1]).format('YYYY-MM-DD');
      this.classSearch.time = [start, end];
    },
    scrollLeftB (val) {
      this.positionA = { x: val };
    },
    downDetail () {
      clearTimeout(this.downTimeout);
      const params = {
       taskId: this.taskId,
        startDate: this.classSearch.time.length === 2 ? this.classSearch.time[0] + ' 00:00:00' : '',
        endDate: this.classSearch.time.length === 2 ? this.classSearch.time[1] + ' 23:59:59' : '',
        siteIdList: this.classSearch.siteIdList,
        classroomClassList: this.classSearch.classroomClassList,
        classroomNoList: this.classSearch.classroomNoList,
        classroomIdList: this.classSearch.classroomIdList
      };
      this.downLoading2 = true;
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.$request.downloadByPost7(
        '/classschedule/scheduleTaskResult/exportClassroomDetail',
        `${this.$t('courseTask.classDetailExport')  }_${  this.taskName  }.xls`,
        params, null, 'xls'
      );
      this.downTimeout = setTimeout(() => {
        this.downLoading2 = false;
      }, 3000);
    },
    exportCalendar () {
      clearTimeout(this.downTimeout2);
      const params = {
        taskId: this.taskId,
        startDate: this.classSearch.time.length === 2 ? this.classSearch.time[0] + ' 00:00:00' : '',
        endDate: this.classSearch.time.length === 2 ? this.classSearch.time[1] + ' 23:59:59' : '',
        siteIdList: this.classSearch.siteIdList,
        classroomClassList: this.classSearch.classroomClassList,
        classroomNoList: this.classSearch.classroomNoList,
        classroomIdList: this.classSearch.classroomIdList
      };
      this.downLoading = true;
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.$request.downloadByPost7(
        '/classschedule/scheduleTaskResult/exportClassroomCalendar',
        `${this.$t('courseTask.classDetailExport2')  }_${  this.taskName  }.xlsx`,
        params, null, 'xlsx'
      );
      this.downTimeout2 = setTimeout(() => {
        this.downLoading = false;
      }, 4000);
    }
  },
  watch: {
    scrollToY (val) {
      this.positionA = { x: val };
    }
  },
  // 离开页面时
  beforeRouteLeave(_to, _from, next){
    this.$refs.gantChild.saveData();
		next();
  },
  mounted() {
    this.popWidth = this.$refs.filterModule.offsetWidth - 110;
    this.orgTypeList = JSON.parse(JSON.stringify(this.orgType));
    if (this.orgTypeList.length === 6) {
      this.orgTypeList.splice(3, 2);
    }
    this.initDate();
    this.searchList();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    clearTimeout(this.downTimeout);
    clearTimeout(this.downTimeout2);
  }
};
</script>
<style lang="scss">
.course-result-class-calendar-contain {
  .calendar-filter {
    height: 80px;
    margin-bottom: 20px;
    .calendar-filter-lf {
      width: 220px;
      height: 100%;
      float: left;
      margin-right: 20px;
      .filter-lf-bottom {
        height: 46px;
        line-height: 62px;
        font-size: 16px;
        .date-title {
          margin-right: 10px;
        }
        .date-tye {
          display: inline-block;
          padding: 0 8px;
          cursor: pointer;
          &.active {
            color: #409eff;
          }
        }
      }
    }
    .calendar-filter-lr {
      float: left;
      width: calc(100% - 240px);
      height: 100%;
      .filter-lr-search {
        width: calc(100% - 90px);
        float: left;
        display: flex;
        flex-wrap: wrap;
        .filter-module {
          flex: 0 0 32%;
          margin-bottom: 12px;
          .filter-module-name {
            line-height: 34px;
            display: block;
            width: 80px;
            float: left;
            text-align: right;
            &.filter-module-name2 {
              color: #409eff;
              cursor: pointer;
              &:hover {
                opacity: .8;
                text-decoration:underline;
              }
            }
            &.filter-module-name3 {
              width: 100px;
            }
          }
          .filter-module-value {
            display: block;
            width: calc(100% - 95px);
            margin-left: 15px;
            float: left;
            &.filter-module-value2 {
              overflow: hidden;
              width: calc(100% - 115px);
            }
            .el-range-editor.el-input__inner {
              width: 100% !important;
            }
          }
        }
      }
      .filter-lr-buttons {
        float: left;
        width: 70px;
        margin-left: 20px;
        .button-margin-b {
          margin-bottom: 12px;
        }
      }
    }
  }
  .class-table-lf {
    width: 50%;
    float: left;
    border-right: 1px solid #dcdee3;
  }
  .class-table-lr {
    width: 50%;
    float: left;
  }
  .calendar-cards {
    line-height: 28px;
    margin-top: 12px;
    font-size: 14px;
    .calendar-card {
      float: left;
      height: 28px;
      border-radius: 3px;
      margin-right: 15px;
      padding: 0 10px;
      background-color: #ebecf0;
      &.calendar-card1 {
        background-color: #4bdc26;
        color: #ffffff;
      }
    }
  }
}
</style>